import ApplicationController from './application_controller';

export default class extends ApplicationController {
  afterReflex() {
    this.element.closest('form').submit();
  }
}
